/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState } from 'react';
import styles from './input.module.scss';
import '../../constants/_global.scss';
import { INPUT_TYPE, InputIterface } from './inputTypes';
import EyeButton from '../eyeButton/eyeButtonComponent';
import ArrowButton from '../arrowButton/arrowComponent';
import { ARROW_DIRECTION } from '../arrowButton/arrowTypes';
import { ReactComponent as SearchIcon } from '../../assets/search.svg';
import { INPUT_GLOBAL_TYPES } from '../../constants/constants';

const Input: React.FC<InputIterface> = ({
  ver,
  onSearch,
  errStatus,
  errMessage,
  placeholder,
  customWidth,
  disabled,
  onChange,
  name,
  accept,
  customMargin,
  inputValue,
}) => {
  const [value, setValue] = useState<string | number>('');
  const [err, setErr] = useState<boolean>(false);
  const [errText, setErrText] = useState<string>('Ошибка');
  const [passVisible, setPassVisible] = useState<boolean>(false);

  useEffect(() => {
    if (errStatus) {
      setErr(true);
      setErrText(errMessage || 'Ошибка');
    } else {
      setErr(false);
    }
  }, [errStatus, errMessage]);

  useEffect(() => {
    if (ver !== INPUT_TYPE.PASSWORD) {
      setPassVisible(true);
    } else {
      setPassVisible(false);
    }
  }, [ver]);

  useEffect(() => {
    setValue(inputValue || '');
  }, [inputValue]);

  const inputMargin = {
    marginBottom: customMargin ? `${customMargin}px` : '8px',
  };

  const mainWidth = {
    margin: '0',
    maxWidth: customWidth ? `${customWidth}px` : '250px',
    width: '100%',
  };

  const style = err
    ? styles.inputError
    : ver === INPUT_TYPE.SEARCH
      ? styles.inputDefaultSearch
      : styles.inputDefault;

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    setValue(newValue);

    if (onChange) {
      onChange(event);
    }
  };

  const renderButton = () =>
    ver === INPUT_TYPE.PASSWORD ? (
      <EyeButton
        onClick={() => setPassVisible(!passVisible)}
        extraClass="icon"
      />
    ) : ver === INPUT_TYPE.SEARCH ? (
      <ArrowButton
        direction={ARROW_DIRECTION.right}
        disabled={false}
        extraClass="icon"
        onClick={onSearch ?? (() => console.log('onSearchErr'))}
      />
    ) : null;

  return (
    <div style={mainWidth}>
      <div style={mainWidth}>
        <div
          className={disabled ? styles.inputDisabled : style}
          style={inputMargin}
        >
          {ver === INPUT_TYPE.SEARCH && (
            <SearchIcon className={styles.searchIcon} />
          )}
          <input
            className={`${styles.inputStandart} spanGlobal`}
            value={value}
            onChange={(e) => handleChange(e)}
            type={!passVisible ? 'password' : 'text'}
            placeholder={placeholder}
            disabled={disabled}
            name={name ?? 'NAME'}
            accept={accept ?? INPUT_GLOBAL_TYPES.Text}
          />
          {renderButton()}
        </div>
      </div>
      {err && <span className={styles.span}>{errText}</span>}
    </div>
  );
};
export default Input;
